/* [ELICO] elico-oos.js — out-of-stock panel: estimated restock date + back-in-stock waitlist.
   Companion of snippets/elico-oos.liquid. Vanilla, no dependencies, idempotent.

   For every [data-elico-oos-data] island on the page:
     • resolves the currently selected variant (input[name="id"] in the section, the
       'elico:variant' CustomEvent, or the ?variant= URL param) and re-checks it on a
       light 300 ms poll — so it works with every buy box without per-section JS wiring;
     • when that variant is unavailable (Shopify's market-aware availability, computed in
       Liquid): shows the ETA line, hides [data-elico-oos-atc] / [data-elico-oos-hide]
       elements in the section, and shows the waitlist button (the section's own
       [data-ebb-waitlist] buttons when native, else the module's own);
     • when available: reverses all of it.
   The waitlist popup posts to Klaviyo's client subscriptions API (same payload as the
   Universal PDP waitlist), list id + public key from the modal's data attributes. */
(function () {
  'use strict';
  if (window.ElicoOOS && window.ElicoOOS.__v === 1) { window.ElicoOOS.scan(); return; }

  var HIDE_SEL = '[data-elico-oos-atc], [data-elico-oos-hide], .product__submit__add[data-add-to-cart], [data-buy-it-now]';
  var instances = [];

  function parseJSON(el) { try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; } }

  function urlVariant() {
    try { var v = new URLSearchParams(location.search).get('variant'); return v ? String(v) : ''; } catch (e) { return ''; }
  }

  /* QA: ?oos_simulate=<variantId>[,<variantId>] previews the sold-out state client-side only
     (nothing changes for anyone else; useful before the inventory policy is flipped) */
  var SIM = [];
  try { SIM = (new URLSearchParams(location.search).get('oos_simulate') || '').split(',').filter(Boolean); } catch (e) {}
  /* QA: ?preorder_simulate=<variantId>[,<variantId>] previews the pre-order state client-side only
     (purchasable + "Forhåndsbestill"); useful before the inventory policy is flipped to continue */
  var SIM_PRE = [];
  try { SIM_PRE = (new URLSearchParams(location.search).get('preorder_simulate') || '').split(',').filter(Boolean); } catch (e) {}

  function Instance(dataEl) {
    this.data = parseJSON(dataEl) || {};
    this.variants = this.data.variants || {};
    for (var s = 0; s < SIM.length; s++) { if (this.variants[SIM[s]]) this.variants[SIM[s]].available = false; }
    for (var sp = 0; sp < SIM_PRE.length; sp++) { if (this.variants[SIM_PRE[sp]]) { this.variants[SIM_PRE[sp]].available = true; this.variants[SIM_PRE[sp]].preorder = true; } }
    this.root = dataEl.closest('.shopify-section') || dataEl.closest('[data-section-id]') || dataEl.parentElement;
    this.panel = this.root.querySelector('[data-elico-oos][data-section-id="' + (this.data.sectionId || '') + '"]') || this.root.querySelector('[data-elico-oos]');
    this.etaEl = this.panel ? this.panel.querySelector('[data-elico-oos-eta]') : null;
    this.modal = this.root.querySelector('[data-elico-oos-modal]');
    this.nativeModal = this.data.native ? this.root.querySelector('[data-wl-modal]') : null;
    this.current = null;
    this.hidden = [];
    this.bindWaitlist();
    this.update(this.resolveVariant() || String(this.data.initial || ''));
  }

  Instance.prototype.resolveVariant = function () {
    /* prefer the section's own hidden id input (all Elico + Palo Alto buy boxes keep one) */
    var inputs = this.root.querySelectorAll('input[name="id"], [data-variant-id]');
    for (var i = 0; i < inputs.length; i++) {
      var val = inputs[i].value || inputs[i].getAttribute('value');
      if (val && this.variants[String(val)]) return String(val);
    }
    var u = urlVariant();
    if (u && this.variants[u]) return u;
    return '';
  };

  Instance.prototype.setHidden = function (on) {
    var els = this.root.querySelectorAll(HIDE_SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      /* Elements matched here are hidden ONLY because of the sold-out state (sections render
         them with `hidden` when the initial variant is sold out) — so un-hiding always means
         "make visible"; we never inherit a server-side `hidden` as the restore state. */
      if (on) {
        el.setAttribute('data-elico-oos-was-hidden', '0');
        el.hidden = true;
        el.setAttribute('aria-hidden', 'true');
      } else if (el.hidden || el.hasAttribute('data-elico-oos-was-hidden')) {
        el.hidden = false;
        el.removeAttribute('data-elico-oos-was-hidden');
        el.removeAttribute('aria-hidden');
      }
    }
    /* native waitlist buttons live inside the section (v3-style buy boxes) */
    if (this.data.native) {
      var wl = this.root.querySelectorAll('[data-ebb-waitlist]');
      for (var j = 0; j < wl.length; j++) {
        wl[j].hidden = !on;
        wl[j].closest('.ebb__sticky') && (wl[j].closest('.ebb__sticky').classList.toggle('elico-oos-sticky-wl', on));
      }
    }
    this.root.classList.toggle('elico-oos--active', on);
  };

  Instance.prototype.update = function (variantId) {
    variantId = String(variantId || '');
    var v = this.variants[variantId];
    if (!v) { return; }
    var oos = v.available === false;
    /* PRE-ORDER: purchasable (continue-selling) but out of stock with a future ETA. The buy
       button stays live and everything else (subscribe, tiers) stays visible — only the label
       and the ETA line change. Computed in Liquid per variant (v.preorder). */
    var pre = !oos && v.preorder === true;
    if (this.current === variantId && this._oos === oos && this._pre === pre) return;
    this.current = variantId; this._oos = oos; this._pre = pre;

    if (this.panel) {
      if (this.etaEl) {
        this.etaEl.textContent = pre ? ((this.data.prePrefix || '') + (v.eta || '')) : (v.eta || '');
        this.etaEl.hidden = !((oos || pre) && v.eta);
      }
      var btn = this.panel.querySelector('[data-elico-oos-btn]');
      /* the module's OWN waitlist button (non-native buy boxes): show only in the sold-out
         (deny) state — never in pre-order, where the customer buys via the live ATC */
      if (btn) { btn.hidden = !oos; }
      var showPanel = (oos && ((v.eta ? true : false) || (btn ? true : false))) || (pre && !!v.eta);
      this.panel.hidden = !showPanel;
    }
    var mEta = this.modal ? this.modal.querySelector('[data-elico-oos-modal-eta]') : null;
    if (mEta) { mEta.textContent = v.eta || ''; mEta.hidden = !v.eta; }
    this.setHidden(oos);   /* pre → oos=false → nothing hidden (subscribe/tiers/ATC all stay) */
    this.applyLabel(v);    /* pre → "Forhåndsbestill"; else → the section's normal label */
    this.root.dispatchEvent(new CustomEvent('elico:oos', { bubbles: true, detail: { variantId: variantId, outOfStock: oos, preorder: pre, eta: v.etaIso || '' } }));
  };

  /* Relabel the add-to-cart button(s) in this section for the resolved variant. Only touches
     the [data-atc-label] text of purchasable, non-disabled ATC buttons — price spans and every
     other control are left alone. Pre-order → "Forhåndsbestill"; otherwise the section's normal
     label. Both come per-variant from the Liquid island (v.label). Sold-out variants keep their
     label owned by the waitlist swap, so we skip them. */
  Instance.prototype.applyLabel = function (v) {
    if (!v || v.available === false) return;
    if (typeof v.label !== 'string' || v.label === '') return;
    var atcs = this.root.querySelectorAll('[data-elico-oos-atc]');
    for (var i = 0; i < atcs.length; i++) {
      var b = atcs[i];
      if (b.disabled || b.hasAttribute('disabled')) continue; /* respect locked buy buttons (deo: pick a scent) */
      var lab = b.querySelector('[data-atc-label]') || b.querySelector('span');
      if (lab && lab.textContent !== v.label) { lab.textContent = v.label; }
    }
  };

  /* ── shared Klaviyo signup: list subscription (consent) + "Back in Stock Signup" event ──
     Every buy box (module popup AND the sections' native popups) goes through here, so one
     universal list receives all signups and each one carries product + variant + market. */
  Instance.prototype.signupContext = function () {
    var v = this.variants[this.current] || {};
    var prod = this.data.product || {};
    return {
      product_title: prod.title || '', product_handle: prod.handle || '', product_id: prod.id || '',
      product_url: prod.url || (location.origin + location.pathname),
      variant_title: v.title || '', variant_id: this.current || '', sku: v.sku || '',
      eta: v.etaIso || '', market: this.data.market || '', locale: this.data.locale || '',
      warehouse: this.data.warehouse || ''
    };
  };

  Instance.prototype.subscribe = function (email, name, cb) {
    var key = this.data.key, list = this.data.list, ctx = this.signupContext();
    var src = (ctx.product_title ? ctx.product_title + (ctx.variant_title && ctx.variant_title !== 'Default Title' ? ' – ' + ctx.variant_title : '') : 'Product') + ' – Back in stock';
    if (!key || !list) { cb({ ok: false, reason: 'notConfigured' }); console.warn('[elico-oos] missing Klaviyo key or list id'); return; }
    var attrs = { email: email };
    if (name) { attrs.first_name = name; }
    attrs.properties = {
      back_in_stock_product: ctx.product_title, back_in_stock_product_handle: ctx.product_handle,
      back_in_stock_variant: ctx.variant_title, back_in_stock_variant_id: ctx.variant_id, back_in_stock_sku: ctx.sku,
      back_in_stock_url: ctx.product_url, back_in_stock_eta: ctx.eta, back_in_stock_market: ctx.market,
      back_in_stock_locale: ctx.locale, back_in_stock_signed_up_at: new Date().toISOString()
    };
    var subPayload = { data: { type: 'subscription', attributes: { custom_source: src,
      profile: { data: { type: 'profile', attributes: attrs } } },
      relationships: { list: { data: { type: 'list', id: list } } } } };
    var evtPayload = { data: { type: 'event', attributes: {
      properties: { ProductTitle: ctx.product_title, ProductHandle: ctx.product_handle, ProductId: ctx.product_id,
        VariantTitle: ctx.variant_title, VariantId: ctx.variant_id, SKU: ctx.sku, ETA: ctx.eta,
        Market: ctx.market, Locale: ctx.locale, Warehouse: ctx.warehouse, URL: ctx.product_url, Source: src },
      metric: { data: { type: 'metric', attributes: { name: 'Back in Stock Signup' } } },
      profile: { data: { type: 'profile', attributes: { email: email, first_name: name || undefined } } } } } };
    var post = function (path, body, signal) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(key), {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(body), signal: signal });
    };
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) { ctrl.abort(); } }, 12000);
    post('subscriptions', subPayload, ctrl ? ctrl.signal : undefined).then(function (r) {
      clearTimeout(timer);
      if (r.ok || r.status === 202) {
        cb({ ok: true });
        /* event is best-effort: never blocks the success state */
        post('events', evtPayload).catch(function (e) { console.warn('[elico-oos] event failed', e); });
      } else {
        r.text().then(function (t) { console.warn('[elico-oos] Klaviyo error', r.status, t); });
        cb({ ok: false, reason: 'generic' });
      }
    }).catch(function (err) {
      clearTimeout(timer); console.warn('[elico-oos] request failed', err);
      cb({ ok: false, reason: 'network' });
    });
  };

  /* wire one popup (module's own or a section's native one) to the shared subscribe */
  Instance.prototype.wirePopup = function (o) {
    var self = this;
    var showError = function (msg) { if (o.error) { o.error.textContent = msg; o.error.hidden = false; } };
    var doSubmit = function (e) {
      if (e && e.preventDefault) { e.preventDefault(); }
      if (e && e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
      if (o.error) { o.error.hidden = true; }
      var emailEl = o.form.querySelector('[name="email"]'), nameEl = o.form.querySelector('[name="first_name"]');
      var email = ((emailEl && emailEl.value) || '').trim(), name = ((nameEl && nameEl.value) || '').trim();
      if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) { showError(o.txt.invalid); return; }
      if (o.submit) { o.submit.setAttribute('aria-busy', 'true'); o.submit.disabled = true; }
      self.subscribe(email, name, function (res) {
        if (o.submit) { o.submit.removeAttribute('aria-busy'); o.submit.disabled = false; }
        if (res.ok) { if (o.wrap) { o.wrap.hidden = true; } if (o.success) { o.success.hidden = false; } }
        else { showError(res.reason === 'network' ? o.txt.network : o.txt.generic); }
      });
    };
    if (o.form.tagName === 'FORM') {
      /* native section popup: take over in the capture phase so the section's own handler never runs */
      o.form.addEventListener('submit', doSubmit, true);
    }
    if (o.submit) { o.submit.addEventListener('click', doSubmit, true); }
    o.form.querySelectorAll('input').forEach(function (inp) {
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); doSubmit(e); } });
    });
  };

  Instance.prototype.bindWaitlist = function () {
    var self = this;
    var opener = this.panel ? this.panel.querySelector('[data-elico-oos-btn]') : null;

    if (this.data.native) {
      if (opener && this.nativeModal) {
        opener.addEventListener('click', function (e) {
          e.preventDefault();
          var nb = self.root.querySelector('[data-ebb-waitlist]');
          if (nb) { nb.click(); } else { self.nativeModal.hidden = false; }
        });
      }
      var nf = this.nativeModal ? this.nativeModal.querySelector('[data-wl-form]') : null;
      if (nf) {
        this.wirePopup({ form: nf, wrap: this.nativeModal.querySelector('[data-wl-form-wrap]'),
          success: this.nativeModal.querySelector('[data-wl-success]'), error: this.nativeModal.querySelector('[data-wl-error]'),
          submit: this.nativeModal.querySelector('[data-wl-submit]'),
          txt: this.data.txt || { invalid: 'Enter a valid email address.', generic: 'Something went wrong.', network: 'We could not sign you up right now.' } });
      }
      return;
    }

    if (!opener) return;
    var modal = this.modal;
    if (!modal) return;
    var form = modal.querySelector('[data-elico-oos-form]');
    var lastFocus = null;
    var open = function () {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('elico-oos-modal-open');
      var first = form ? form.querySelector('input[type="text"]') || form.querySelector('input[type="email"]') : null;
      if (first) { setTimeout(function () { first.focus(); }, 40); }
    };
    var close = function () {
      modal.hidden = true;
      document.documentElement.classList.remove('elico-oos-modal-open');
      if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
    };
    opener.addEventListener('click', function (e) { e.preventDefault(); open(); });
    modal.querySelectorAll('[data-elico-oos-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    if (!form) return;
    this.wirePopup({ form: form, wrap: modal.querySelector('[data-elico-oos-form-wrap]'),
      success: modal.querySelector('[data-elico-oos-success]'), error: modal.querySelector('[data-elico-oos-error]'),
      submit: modal.querySelector('[data-elico-oos-submit]'),
      txt: { invalid: modal.getAttribute('data-txt-invalid') || 'Enter a valid email address.',
             generic: modal.getAttribute('data-txt-generic') || 'Something went wrong.',
             network: modal.getAttribute('data-txt-network') || 'We could not sign you up right now.' } });
  };
  function scan() {
    document.querySelectorAll('[data-elico-oos-data]:not([data-elico-oos-bound])').forEach(function (el) {
      el.setAttribute('data-elico-oos-bound', '1');
      var inst = new Instance(el);
      if (inst.panel) { instances.push(inst); }
    });
  }

  function tick() {
    for (var i = 0; i < instances.length; i++) {
      var inst = instances[i];
      if (!document.body.contains(inst.root)) continue;
      var vid = inst.resolveVariant();
      if (vid && vid !== inst.current) { inst.update(vid); }
      /* Palo Alto's product-form re-renders its submit button after load / on option change —
         re-apply the hide while sold out so freshly rendered buttons don't reappear */
      else if (inst._oos) { inst.setHidden(true); }
      /* same re-render risk for pre-order: a section that rewrote its own ATC label loses
         "Forhåndsbestill" — re-apply it (cheap; only writes when the text actually differs) */
      else if (inst._pre) { inst.applyLabel(inst.variants[inst.current]); }
    }
  }

  /* explicit hook for custom buy boxes */
  document.addEventListener('elico:variant', function (e) {
    var d = (e && e.detail) || {};
    for (var i = 0; i < instances.length; i++) {
      var inst = instances[i];
      if (!d.sectionId || inst.data.sectionId === d.sectionId) inst.update(d.variantId);
    }
  });
  /* Palo Alto product-form: variant change → class flip on [data-form-wrapper] + option change events */
  document.addEventListener('change', function () { setTimeout(tick, 0); }, true);
  document.addEventListener('theme:variant:change', function () { setTimeout(tick, 0); });
  window.addEventListener('popstate', tick);
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    if (typeof orig !== 'function') return;
    history[m] = function () { var r = orig.apply(this, arguments); setTimeout(tick, 0); return r; };
  });
  /* safety net: cheap poll (one input read per island) while the tab is visible */
  setInterval(function () { if (!document.hidden) tick(); }, 300);
  document.addEventListener('shopify:section:load', scan);

  window.ElicoOOS = {
    __v: 1, scan: scan, instances: instances,
    update: function (sectionId, variantId) {
      document.dispatchEvent(new CustomEvent('elico:variant', { detail: { sectionId: sectionId, variantId: variantId } }));
    },
    /* QA helper (client-side only): ElicoOOS.simulate(variantId, true) previews the sold-out state
       for a variant that is still purchasable; simulate(variantId, false) restores it. */
    simulate: function (variantId, outOfStock) {
      variantId = String(variantId);
      for (var i = 0; i < instances.length; i++) {
        var inst = instances[i], v = inst.variants[variantId];
        if (!v) continue;
        v.available = !outOfStock;
        inst.current = null; inst.update(inst.resolveVariant() || variantId);
      }
    },
    /* QA helper (client-side only): ElicoOOS.preorder(variantId) previews the pre-order state
       ("Forhåndsbestill" + prefixed ETA) for a variant that is still purchasable. */
    preorder: function (variantId) {
      variantId = String(variantId);
      for (var i = 0; i < instances.length; i++) {
        var inst = instances[i], v = inst.variants[variantId];
        if (!v) continue;
        v.available = true; v.preorder = true;
        inst.current = null; inst.update(inst.resolveVariant() || variantId);
      }
    }
  };

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
})();
